<template>
  <div>
    <div class="breadcrumb-wrapper">
      <ul class="breadcrumb-list">
        <li>
          <router-link :to="{ name: 'HomePage' }">
            <i class="fa fa-home"></i>
            Home
          </router-link>
        </li>
        <li class="active">
          <i class="fa fa-user-cog"></i>
          My Account
        </li>
      </ul>
    </div>

    <div class="page-content-wrapper">
      <!--=======  my account wrapper  =======-->

      <div class="myaccount-wrapper">
        <div class="container">
          <div class="text-center" v-if="loading">
            <div class="spinner-border text-info" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-12 col-xs-12 col-lg-6">
              <div class="login-form login-form--extra-space">
                <h4 class="login-title">Account Information</h4>

                <div class="row">
                  <div class="col-md-12 col-12">
                    <div class="mb-2">
                      <label>Name</label>
                      <input
                        type="text"
                        placeholder="Name"
                        v-model="fullName"
                        class="bg-light"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-2">
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="Email Address"
                        v-model="email"
                        class="bg-light"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-2">
                      <label>Company</label>
                      <input
                        type="text"
                        placeholder="Company"
                        v-model="company"
                        class="bg-light"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-xs-12 col-lg-6">
              <change-password />
            </div>
          </div>
        </div>
      </div>

      <!--=======  End of my account wrapper  =======-->
    </div>
  </div>
</template>

<script>
import changePassword from "./ChangePassword.vue";
export default {
  components: {
    changePassword,
  },
  data() {
    return {
      loading: false,
      fullName: null,
      email: null,
      company: null,
    };
  },
  async mounted() {
    this.loading = true;
    let resp = await this.$http.get(`Settings/UserInfo`);
    if (resp && resp.status == 200 && resp.data) {
      let respData = resp.data;
      this.fullName = respData.data.name;
      this.email = respData.data.email;
      this.company = respData.data.company;
    }
    this.loading = false;
  },
};
</script>
